// Aides PURES de la page Audit (sans axios ni React) : construction des query params du journal
// filtré et bornes de période. Séparées du client HTTP pour rester testables en isolation.
// Le repli des plages inchangées du diff vit dans Helper/yamlDiff (partagé), ré-exporté ici.
export { foldUnchanged } from "../../Helper/yamlDiff";
export type { RenderRow } from "../../Helper/yamlDiff";

export interface AuditFilters {
	/** Clé d'acteur EXACTE : le courriel de l'annuaire de préférence (colonne UserEmail), sinon le
	 *  nom d'affichage (colonne User) ; le serveur matche les deux colonnes. */
	actor?: string;
	level?: string;
	type?: string;
	/** Bornes UTC ISO : since inclusif, until exclusif (le serveur applique >= / <). */
	since?: string;
	until?: string;
	search?: string;
	includeDebug?: boolean;
}

/** Une journée saisie au format yyyy-mm-dd devient une borne UTC ISO ; la borne de fin est
 *  EXCLUSIVE côté serveur, donc « jusqu'au 15/08 » envoie le 16/08 à minuit. */
export const dayToIsoSince = (day: string): string | undefined =>
	day ? new Date(`${day}T00:00:00`).toISOString() : undefined;
export const dayToIsoUntil = (day: string): string | undefined => {
	if (!day) return undefined;
	const d = new Date(`${day}T00:00:00`);
	d.setDate(d.getDate() + 1);
	return d.toISOString();
};

/** Ne poser que les params réellement contraints : un param vide fausserait le filtre serveur. */
export const buildAuditParams = (page: number, pageSize: number, filters: AuditFilters): Record<string, string | number | boolean> => {
	const params: Record<string, string | number | boolean> = {
		page,
		pageSize,
		includeDebug: filters.includeDebug ?? false
	};
	if (filters.actor?.trim()) params.actor = filters.actor.trim();
	if (filters.level?.trim()) params.level = filters.level.trim();
	if (filters.type?.trim()) params.type = filters.type.trim();
	if (filters.since?.trim()) params.since = filters.since.trim();
	if (filters.until?.trim()) params.until = filters.until.trim();
	if (filters.search?.trim()) params.search = filters.search.trim();
	return params;
};

